// extracted by mini-css-extract-plugin
export default {"heading":"heading-trn8V","item":"item-Xnmf8"};